module.exports = __webpack_public_path__ + "static/media/JungleDrum.2c58a2ca.mp3";